import { render, staticRenderFns } from "./thirdlogin.vue?vue&type=template&id=4104db0c&scoped=true"
import script from "./thirdlogin.vue?vue&type=script&lang=js"
export * from "./thirdlogin.vue?vue&type=script&lang=js"
import style0 from "./thirdlogin.vue?vue&type=style&index=0&id=4104db0c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4104db0c",
  null
  
)

export default component.exports